/**
 * @author yili
 * @fileoverview 全局前置守卫
 */

// 账号权限
let timestamp = +new Date();
// const BASEURL = process.env.VUE_APP_BASE_API;
import { reportData } from "@/api/common";

function projectRecord(curUrl, chygPageTag, stopTime = 0) {
  const params = {
    event_name: "page-view",
    current_page_title: document.title,
    current_page_url: curUrl,
    duration: stopTime,
  };
  if (curUrl) {
    reportData(params).then(() => {});
  }
}

window.onload = () => {
  projectRecord(
    window.location.href,
    encodeURIComponent(window.location.pathname),
    +new Date() - timestamp
  );
};

function titleGuard(to, from) {
  const currentTimestamp = +new Date();
  const diff = currentTimestamp - timestamp;
  // 进入立即replace的不上报
  if (diff > 300) {
    timestamp = currentTimestamp;

    projectRecord(
      `${window.location.origin}${from.fullPath}`,
      encodeURIComponent(from.path),
      diff
    );
  }
}

export default [titleGuard];
